export default __webpack_public_path__ + "static/media/monetization_persona_avatar.1c7b0c32.png";